export enum MenuKey {
  Seller = '1',
  Creator = '2',
}
